import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class LoginContainer extends ThemeComponent {
    @Ref() normalLogin!: HTMLDivElement;
    @Ref() forgotPassword!: HTMLDivElement;
    @Ref() showForgotPasswordButton!: HTMLSpanElement;
    @Ref() hideForgotPasswordButton!: HTMLButtonElement;
    @Ref() forgotPasswordSuccessMessage!: HTMLElement;
    @Ref({ required: false }) forgotPasswordPostedSuccessfully!: HTMLSpanElement;

    init() {

        // Show forgot password
        this.$listen(this.showForgotPasswordButton, 'click', () => {
            this.normalLogin.classList.add('visually-hidden');
            this.forgotPassword.classList.remove('visually-hidden');
        });

        // Allow deep linking to the recover password form
        if (window.location.hash == '#recover') {
            this.normalLogin.classList.add('visually-hidden');
            this.forgotPassword.classList.remove('visually-hidden');
        }

        // Hide forgot password
        this.$listen(this.hideForgotPasswordButton, 'click', () => {
            this.normalLogin.classList.remove('visually-hidden');
            this.forgotPassword.classList.add('visually-hidden');
        });

        // Show success essage
        if (this.forgotPasswordPostedSuccessfully) {
            this.forgotPasswordSuccessMessage.classList.remove('visually-hidden');
        }
    }
}
